var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMhc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9199 -8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9199 8200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13265.741 5908.859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4084.745,2320.437a11.3,11.3,0,1,1,11.3-11.135A11.257,11.257,0,0,1,4084.745,2320.437Zm.006-2.061a9.231,9.231,0,1,0-9.254-9.275A9.2,9.2,0,0,0,4084.751,2318.376Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4203.886,2356.293c0,.945,0,1.889,0,2.834a1.027,1.027,0,0,0,.541,1.011c.3.162.57.374.854.563,1.09.727,2.18,1.457,3.274,2.179a.881.881,0,0,0,1.327-.108c.517-.572.378-1.179-.391-1.693-1.056-.706-2.108-1.419-3.173-2.111a.757.757,0,0,1-.4-.731c.024-1,.011-1.994.007-2.991,0-.722.005-1.444-.027-2.164a.881.881,0,0,0-.88-.832c-.726-.036-1.113.335-1.126,1.131C4203.874,2354.352,4203.886,2355.323,4203.886,2356.293Z",
    transform: "translate(-120.17 -50.119)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4203.886,2356.293c0-.971-.012-1.942,0-2.913.013-.8.4-1.167,1.126-1.131a.881.881,0,0,1,.88.833c.032.72.024,1.442.027,2.164,0,1,.017,1.994-.007,2.991a.757.757,0,0,0,.4.731c1.065.691,2.117,1.4,3.173,2.111.769.515.908,1.121.391,1.693a.881.881,0,0,1-1.327.108c-1.095-.722-2.184-1.452-3.274-2.178-.283-.189-.555-.4-.854-.563a1.027,1.027,0,0,1-.541-1.011C4203.888,2358.183,4203.886,2357.238,4203.886,2356.293Z",
    transform: "translate(-120.17 -50.118)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMhc);
export default __webpack_public_path__ + "static/media/icon-mhc.9c091e79.svg";
export { ForwardRef as ReactComponent };